import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, createElementVNode as _createElementVNode, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-c8bcdafa"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "flex wrap",
  style: {"gap":"24px"}
}
const _hoisted_2 = { class: "shop-item" }
const _hoisted_3 = { class: "flex grow align-center justify-center" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "text-muted" }, "Nouveau", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_DatabaseShopItemCard = _resolveComponent("DatabaseShopItemCard")!
  const _component_SeImage = _resolveComponent("SeImage")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.state.shopItems, (item) => {
      return (_openBlock(), _createBlock(_component_DatabaseShopItemCard, { shopItem: item }, null, 8, ["shopItem"]))
    }), 256)),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", {
          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.addShopItem && _ctx.addShopItem(...args))),
          class: "flex add-btn"
        }, [
          _hoisted_4,
          _createVNode(_component_SeImage, { src: "/ico/plus-blue.svg" })
        ])
      ])
    ])
  ]))
}